import { FC, ReactNode } from "react";
import { Box, Tooltip, Zoom, Typography } from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";

import { Colors } from "../../../configs";

import Marquee from "react-fast-marquee";

export interface ISingleDetailProps {
  label: string;
  value: string | number;
  numberOfColumns?: number;
  color?: string;
  isMarquee?: boolean;
  onClick?: () => void;
  icon?: ReactNode;
}

const SingleDetail: FC<ISingleDetailProps> = ({
  label,
  value,
  numberOfColumns = 1,
  color = Colors.PRIMARY,
  isMarquee = false,
  onClick,
  icon,
}) => {
  return (
    <Tooltip
      title={<Typography style={{ fontSize: "1rem" }}>{value}</Typography>}
      placement="top"
      TransitionComponent={Zoom}
      leaveDelay={100}
      enterTouchDelay={0}
      disableFocusListener
      arrow
    >
      <Box
        sx={{
          background: Colors.WHITE,
          flexDirection: "row",
          borderRadius: "0.57rem",
          alignItems: "center",
          fontSize: "1rem",
          width:
            "calc((100% - " +
            (numberOfColumns > 1 ? (numberOfColumns - 1) * 1.78571429 : 0) +
            "rem) / " +
            numberOfColumns +
            ")",
          boxSizing: "border-box",
          display: "flex",
          alignSelf: "stretch",
          cursor: onClick ? "pointer" : "auto",
        }}
        onClick={onClick ? onClick : undefined}
      >
        <Box
          sx={{
            background: color,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            borderRadius: "0.57rem",
            padding: "0.57rem 0.928571429rem",
            paddingRight: "1.14rem",
            color: Colors.WHITE,
            minWidth: "11.4285714rem",
            boxSizing: "border-box",
            height: "100%",
          }}
        >
          {icon && (
            <Box sx={{ display: "flex", alignItems: "center", mr: "0.5rem", flexShrink: 0 }}>
              {icon}
            </Box>
          )}
          <Typography
            style={{ fontSize: "1rem", lineHeight: "1rem" }}
            test-name={`single-detail-${label.toLowerCase().replace(" ", "-")}`}
          >
            {label}
          </Typography>
          {onClick && <LaunchIcon sx={{ ml: "auto" }} />}
        </Box>
        <Box
          sx={{
            padding: "0.60rem 0.928571429rem 0.60rem 1.14rem",
            width: "calc(100% - 11.4285714rem)",
            boxSizing: "border-box",
            overflow: "hidden",
            background: "linear-gradient(to right, #F3F3F3, #E0E0E0)",
            borderRadius: "0 0.57rem 0.57rem 0",
            boxShadow: "inset 0 2px 4px rgba(0,0,0,0.06)",
          }}
        >
          {isMarquee ? (
            <Marquee gradient={false} speed={40}>
              <Typography
                sx={{
                  fontSize: "1rem",
                  lineHeight: "1rem",
                  color: "#515151",
                  paddingRight: "2rem",
                }}
              >
                {value}
              </Typography>
            </Marquee>
          ) : (
            <Typography
              sx={{
                width: "100%",
                fontSize: "1rem",
                lineHeight: "1rem",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                color: "#515151",
              }}
            >
              {value}
            </Typography>
          )}
        </Box>
      </Box>
    </Tooltip>
  );
};

export default SingleDetail;
